import React from 'react'
import { StyleSheet } from 'react-native'
import { DNABox, DNACard, DNAIcon, DNAText, Iffy, colors } from '@alucio/lux-ui'
import { FolderORM } from 'src/types/types'
import { useDNAFolderActions } from 'src/components/DNA/Folder/DNAFolder.actions'
import { useAppSettings } from 'src/state/context/AppSettings'
import { GRID_LIST_STYLES_VARIANTS_CONFIGS } from 'src/screens/MyFolders/constants'
import PinButton from 'src/components/DNA/Folder/DNAFolderPinButton'
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types'
import DNAFolderStatusChip from 'src/components/DNA/Chip/DNAFolderStatusChip'

export interface DNAFolderMeetingRowProps {
  onPin?: () => void,
}

const styles = StyleSheet.create({
  containerStyle: {
    backgroundColor: colors['color-white-transparent-6'],
    borderRadius: 4,
    marginVertical: 4,
    minHeight: 70,
    maxHeight: 70,
    justifyContent: 'center',
    paddingHorizontal: 24,
  },
  titleText: {
    marginLeft: 6,
  },
})

export const DNAFolderMeetingRow: DNARowsComponent<FolderORM, DNAFolderMeetingRowProps> = (props) => {
  const {
    ORM: folderORM,
    onPin,
    onPress,
  } = props
  const { deviceMode } = useAppSettings()
  const folderActions = useDNAFolderActions()

  const isPinned = folderORM.meta.isFavorite && !folderORM.relations.parentFolderORM;

  return (
    <DNACard
      appearance="flat"
      style={[
        props.style,
        styles.containerStyle,
      ]}
      interactive="pressable"
      onPress={() => {
        onPress?.(folderORM);
      }}
    >
      <DNABox testID="folder-row" alignY="center">
        <DNABox fill alignY="center" spacing="sm">
          <DNABox alignY="center" alignX="end">
            {
              <PinButton
                onPin={() => {
                  folderActions.pin(folderORM)();
                  onPin?.();
                }}
                variant="virtual"
                isHidden={!isPinned}
                isPinned={isPinned}
                interactive={false}
              />
            }
          </DNABox>
          <DNABox alignY="center" alignX="center">
            <DNAIcon.Styled
              name="folder-simple-fill"
              appearance="ghost"
              color={colors['color-ui2-brand-400']}
              width={GRID_LIST_STYLES_VARIANTS_CONFIGS.FOLDER_ICON[deviceMode].width}
              height={GRID_LIST_STYLES_VARIANTS_CONFIGS.FOLDER_ICON[deviceMode].height}
            />
          </DNABox>
          <DNAText testID="folder-item-title" b1 colorMode="dark" numberOfLines={2} style={styles.titleText}>
            {folderORM.model.name}
          </DNAText>
          <Iffy is={folderORM.meta.isSharedFolder && !folderORM.meta.isSharedWithTheUser}>
            <DNAFolderStatusChip folderStatus="SHARED" />
          </Iffy>
          <Iffy is={folderORM.meta.isSharedWithTheUser}>
            <DNAFolderStatusChip folderStatus="SHARED_WITH_ME" />
          </Iffy>
        </DNABox>
      </DNABox>
    </DNACard>
  );
}

export default DNAFolderMeetingRow
